import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles<Theme>(({ palette, spacing }) => ({
  button_back: {
    backgroundColor: `${palette.primary.main}10`,
    borderRadius: spacing(0.5),
    height: "100%",
    marginRight: spacing(2),
    width: 20,
  },
}));
